import React from "react";
import "./CustomMainPage.css";

export default function CustomMainPage({ slots = [], groups = [], layout = {}, error = "" }) {
  return (
    <section className="custom-main-page">
      {error ? <div className="custom-main-page__error">{error}</div> : null}

      <div className="custom-main-page__hero">
        <span>직접 메인 파일</span>
        <h2>이 파일을 수정해서 프론트 메인을 직접 꾸밉니다.</h2>
        <p>
          이 영역은 헤더, 로고, 메인메뉴 아래 콘텐츠 영역입니다.
          파일명은 바꾸지 말고 이 파일 내용만 수정하세요.
        </p>
      </div>

      <div className="custom-main-page__info-grid">
        <article>
          <strong>수정 파일</strong>
          <code>frontend-next/src/pages/main/custom/CustomMainPage.js</code>
        </article>
        <article>
          <strong>현재 그리드 설정</strong>
          <span>{layout?.preset || "grid"} / {layout?.device_count || slots.length || 0} slots</span>
        </article>
        <article>
          <strong>전달 데이터</strong>
          <span>slots {slots.length}개, groups {groups.length}개</span>
        </article>
      </div>
    </section>
  );
}
